<template>
  <TooltipBase
    :placement="`${tooltipLocalizacao}`"
    v-model="visible"
    :name="nome"
    :maxWidth="larguraMaxima"
    :minWidth="larguraMinima"
    :minHeight="alturaMinima"
    :nowrap="whiteSpaceNoWrap"
    :maxHeight="alturaMaxima"
    :arrowWidth="arrowWidth"
    :largura="largura"
  >
    <div
      slot="outlet"
      v-if="texto"
      @click="$emit('click')"
      :style="estiloTexto || ''"
    >
      {{ texto }}
    </div>
    <div slot="outlet" v-else>
      <slot name="itemTooltip" />
    </div>
    <div
      slot="tooltip"
      style="word-wrap: break-word"
      :style="estiloTextoTooltip || ''"
      v-if="textoTooltip"
    >
      {{ textoTooltip }}
    </div>
    <div slot="tooltip" style="word-wrap: break-word" v-else>
      <slot name="conteudo-tooltip" />
    </div>
  </TooltipBase>
</template>

<script>
import TooltipBase from "./TooltipBase";

export default {
  components: {
    TooltipBase
  },
  name: "TooltipUnimed",
  props: {
    visualizando: {
      type: Boolean,
      default: true,
      note: "V-model do tooltip"
    },
    texto: {
      type: String,
      default: "",
      required: false,
      note: "Deve ser passado o nome do texto que ira aparecer"
    },
    textoTooltip: {
      type: String,
      default: "",
      required: false,
      note: "Deve ser passado o nome do texto que ira aparecer no tooltip"
    },
    tooltipLocalizacao: {
      type: String,
      default: "top",
      note:
        "Deve ser passado onde tooltip ira aparecer em volta do texto que ira ser apresentado, escolher um dos valores: top,left,right,bottom"
    },
    nome: {
      type: String,
      default: "Tooltip-Padrao",
      require: false,
      note: "Nome do campo"
    },
    larguraMaxima: {
      type: Number,
      default: 0
    },
    larguraMinima: {
      type: Number,
      default: 0
    },
    alturaMinima: {
      type: Number,
      default: 0
    },
    alturaMaxima: {
      type: Number,
      default: 0
    },
    whiteSpaceNoWrap: {
      type: Boolean,
      default: true
    },
    estiloTexto: {
      type: Object,
      default: () => {}
    },
    estiloTextoTooltip: {
      type: Object,
      default: () => {}
    },
    arrowWidth: {
      type: Number,
      default: 10
    },
    largura: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      visible: this.visualizando
    };
  }
};
</script>
